export default "__VITE_ASSET__Dte$Apm3__"